﻿function initializeAptrinsic(tagKey, sdkUrl, user, account) {
    installAptrinsicSDK(tagKey, sdkUrl);
    aptrinsic("identify",
        {
            //User Fields
            employeeNum: user.employeeNum,
            id: user.id,
            email: user.email,
            emailDomain: user.emailDomain,
            firstName: user.firstName,
            lastName: user.lastName,
            isSystemAdmin: user.isSystemAdmin,
            isHRUser: user.isHRUser,
            isFieldUser: user.isFieldUser,
            isFCUser: user.isFCUser,
            enableCrewEditing: user.enableCrewEditing,
            isTermLock: user.isTermLock,
            isAuthFMobile: user.isAuthFMobile,
            isAuthFieldService: user.isAuthFieldService,
            isActiveTechnician: user.isActiveTechnician,
            isEverInvoiceReviewer: user.isEverInvoiceReviewer,
            otherAdmins: user.otherAdmins,
            positionDesc: user.positionDesc,
        },
        {
            //Account Fields
            id: account.id,
            name: account.name,
            portalUrl: account.portalUrl,
            portalVersion: account.portalVersion,
            vistaVersion: account.vistaVersion,
            customerID: account.customerID,
            countryCode: account.countryCode,
            timeClockEnabled: account.timeClockEnabled,
            timeClockNonKiosk: account.timeClockNonKiosk,
            licenseHR: account.licenseHR,
            licenseFC: account.licenseFC,
            licenseFM: account.licenseFM,
            licenseFS: account.licenseFS,
        });
}

function installAptrinsicSDK(tagKey, sdkUrl) {
    if (!tagKey) {
        return;
    }
    try {
        new URL(sdkUrl);
    }
    catch (_) {
        return;
    }

    (function (n, t, a, e, co) {
        var i = "aptrinsic"; n[i] = n[i] || function () {
            (n[i].q = n[i].q || []).push(arguments)
        }, n[i].p = e; n[i].c = co;
        var r = t.createElement("script"); r.async = !0, r.src = a + "?a=" + e;
        var c = t.getElementsByTagName("script")[0]; c.parentNode.insertBefore(r, c)
    })(window, document, sdkUrl, tagKey);
}